import { WhenAllReady } from "@nimble/react-requests/components/shared/when-all-ready";
import { getInnerQueryData } from "@nimble/react-requests/data/response-utils";

import AppDrawer from "@/app/(discover)/components/app-drawer";
import DistrictJobDetailsHeader from "@/components/shared/jobs/district-job-details-drawer/district-job-details-header";
import DistrictJobDetailsPanel from "@/components/shared/jobs/district-job-details-drawer/district-job-details-panel";
import JobDetailsContentSkeleton from "@/components/shared/jobs/job-details/job-details-content.skeleton";
import JobDetailsDescription from "@/components/shared/jobs/job-details/job-details-description";
import useDistrictData from "@/hooks/data/use-district-data";
import useJobPostingData from "@/hooks/data/use-job-posting";

interface DistrictJobDetailsDrawerViewProps {
  jobQuery: ReturnType<typeof useJobPostingData>;
  districtQuery: ReturnType<typeof useDistrictData>;
  jobHref: string;
  interestMessage: string;
  onClose: () => void;
}

export default function DistrictJobDetailsDrawerView({
  jobQuery,
  districtQuery,
  jobHref,
  interestMessage,
  onClose,
}: DistrictJobDetailsDrawerViewProps) {
  const jobPosting = getInnerQueryData(jobQuery);
  const district = getInnerQueryData(districtQuery);

  return (
    <AppDrawer
      onClose={onClose}
      title="Job Details"
      className="p-0 md:!max-h-[90vh] will-change-transform"
    >
      <div className="max-w-5xl w-full h-full mx-auto overflow-y-auto">
        <WhenAllReady
          queries={[jobQuery, districtQuery]}
          loader={<JobDetailsContentSkeleton />}
          ErrorWrapper={({ errorEl }) => <div className="p-6">{errorEl}</div>}
        >
          {jobPosting && district && (
            <div className="w-full mx-auto px-4 sm:px-6 py-6">
              <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-8">
                <div className="flex flex-col gap-6 lg:flex-1 lg:pr-2">
                  <DistrictJobDetailsHeader
                    jobPosting={jobPosting}
                    district={district}
                    jobHref={jobHref}
                  />
                  <JobDetailsDescription jobPosting={jobPosting} />
                </div>
                <div className="lg:w-[320px] lg:flex-shrink-0">
                  <DistrictJobDetailsPanel
                    jobPosting={jobPosting}
                    district={district}
                    jobHref={jobHref}
                    interestMessage={interestMessage}
                  />
                </div>
              </div>
            </div>
          )}
        </WhenAllReady>
      </div>
    </AppDrawer>
  );
}
